import styled from 'styled-components';
import { createMuiTheme } from '@material-ui/core';
import { Color, getTheme } from '../../ThemeProvider/ThemeStyle';
import lodash from 'lodash';
import green from '@material-ui/core/colors/green';

export const tableTheme = createMuiTheme(
  lodash.merge(getTheme(), {
    props: {
      MuiInputBase: {
        inputProps: {
          style: {
            paddingBottom: 4,
            paddingTop: 4
          }
        }
      },
      MuiSelect: {
        SelectDisplayProps: {
          style: {
            paddingBottom: 4,
            paddingTop: 3
          }
        }
      },
      MuiTextField: {
        style: {
          marginTop: 0,
          marginBottom: 0
        },
        inputProps: {
          style: {
            paddingBottom: 4,
            paddingTop: 4
          }
        }
      },
      MuiTableCell: {
        style: {
          padding: 0,
          minWidth: 250,
          maxWidth: 300,
          height: 33
        }
      }
    },
    overrides: {
      MuiInputAdornment: {
        positionEnd: {
          marginLeft: 0
        }
      },
      MuiFormHelperText: { contained: { paddingLeft: 15, marginTop: 0 } },
      MuiFormControl: { root: { marginTop: 0, marginBottom: 0 } },
      MuiAutocomplete: {
        input: {
          padding: '6px 14px !important'
        }
      },
      MuiOutlinedInput: {
        input: {
          paddingBottom: '6px !important',
          paddingTop: '6px !important'
        }
      },
      MuiInputBase: {
        root: {
          height: 'inherit',
          '&$disabled': {
            background: 'transparent'
          }
        }
      }
    }
  })
);

export const Wrapper = styled.div`
  margin: 16px 0;
  :first-child {
    margin-top: 0;
  }
  :last-child {
    margin-bottom: 0;
  }
  table {
    background-color: ${() => Color.bgColorPaper};
    border-collapse: separate;
    border-radius: ${() => Color.borderRadius};
    border-top: 1px solid ${() => Color.border};
    border-left: 1px solid ${() => Color.border};
    ${props => (props.error ? 'border: 1px solid red;' : '')};
  }
  td {
    fieldset {
      display: none !important;
    }
    border-right: 1px solid ${() => Color.border};
  }
  tr:last-child {
    td {
      :first-child {
        border-bottom-left-radius: ${() => Color.borderRadius};
      }
      :last-child {
        border-bottom-right-radius: ${() => Color.borderRadius};
      }
    }
  }
  th {
    border-right: 1px solid ${() => Color.border};
    padding: 7px 15px !important;
    font-size: 13px !important;
    line-height: 1;
    :first-child {
      border-top-left-radius: ${() => Color.borderRadius};
    }
    :last-child {
      border-top-right-radius: ${() => Color.borderRadius};
    }
  }
  .row-number,
  .action-delete {
    text-align: center;
    width: 50px !important;
    min-width: 50px !important;
  }
  .column-title {
    background-color: rgba(125, 125, 125, 0.1);
    height: 36px;
  }
  .add-row {
    margin-top: 5px;
    padding: 2px 15px;
    background-color: ${() => Color.bgColor};
  }
  .Mui-error {
    background-color: #ff003308 !important;
  }
  .cell-disabled {
    background-color: rgba(125, 125, 125, 0.1);
  }
  .cell-changed {
    border-bottom: 3px solid ${green[200]};
  }
`;
